import axios from "axios";

export const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API,
  withCredentials: true,
});

export const LOGO_URL =
  "https://customer-assets-jai6qajn.emergentagent.net/job_abe-events/artifacts/0q639go4_image.png";

export const IMAGE_PLACEHOLDER =
  "data:image/svg+xml;charset=utf-8," +
  encodeURIComponent(
    "<svg xmlns='http://www.w3.org/2000/svg' width='800' height='800'><rect width='100%' height='100%' fill='#18181B'/></svg>"
  );

export function imageUrl(val) {
  if (!val) return IMAGE_PLACEHOLDER;
  if (val.startsWith("http") || val.startsWith("data:")) return val;
  return `${API}/files/${val}`;
}

export function money(n) {
  const v = Number(n || 0);
  return `$${v.toFixed(2)}`;
}

export function formatApiError(detail) {
  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail
      .map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e)))
      .filter(Boolean)
      .join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

const MONTHS = ["JAN","FEB","MAR","APR","MAY","JUN","JUL","AUG","SEP","OCT","NOV","DEC"];
const FULL_MONTHS = ["January","February","March","April","May","June","July","August","September","October","November","December"];
const DAYS = ["Sun","Mon","Tue","Wed","Thu","Fri","Sat"];

export function parseDate(dateStr) {
  if (!dateStr) return null;
  const [y, m, d] = dateStr.split("-").map(Number);
  return new Date(y, m - 1, d);
}

export function dateBadge(dateStr) {
  const dt = parseDate(dateStr);
  if (!dt) return { month: "", day: "" };
  return { month: MONTHS[dt.getMonth()], day: String(dt.getDate()) };
}

export function fullDate(dateStr) {
  const dt = parseDate(dateStr);
  if (!dt) return "";
  return `${DAYS[dt.getDay()]}, ${FULL_MONTHS[dt.getMonth()].slice(0,3)} ${dt.getDate()}, ${dt.getFullYear()}`;
}
